// 2020-06-27export { TropaCorralComponent } from './tropa-corral.component';